// extracted by mini-css-extract-plugin
export default {"root":"_35-EU","label":"_1bPIH","updated-ui":"Jpfhd","updatedUi":"Jpfhd"};